function capitalize(text = '') {
  return `${text.charAt(0).toUpperCase()}${text.substr(1)}`;
}

// eslint-disable-next-line import/prefer-default-export
export function transformPrivateInfo(data) {
  const { userId, ...changes } = data;

  if (changes.firstName) {
    Object.assign(changes, {
      firstName: capitalize(changes.firstName),
    });
  }

  if (changes.lastName) {
    Object.assign(changes, {
      lastName: capitalize(changes.lastName),
    });
  }

  return changes;
}
